var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouseWind(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_1",
    "data-name": 1,
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.514,
    height: 58.999,
    viewBox: "0 0 65.514 58.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(5.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M0,59V21.2L26.371,0,38.238,9.539V6.713h6.153v7.773L52.742,21.2V59Z",
    fill: "#e6f6fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2",
    "data-name": "Path 2",
    transform: "translate(4.03 4.833)",
    fill: "#e6f6fb",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 43.92268371582031 50.133056640625 L 0.750001847743988 50.133056640625 L 0.750001847743988 18.07500267028809 L 22.34074020385742 0.9571890830993652 L 43.92268371582031 18.07490921020508 L 43.92268371582031 50.133056640625 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22.34064292907715 1.914386749267578 L 1.5 18.4375 L 1.5 49.383056640625 L 43.17268371582031 49.383056640625 L 43.17268371582031 18.43732070922852 L 22.34064292907715 1.914386749267578 M 22.3408317565918 -3.814697265625e-06 L 44.67268371582031 17.71250534057617 L 44.67268371582031 50.883056640625 L 0 50.883056640625 L 0 17.71250534057617 L 22.3408317565918 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "breathable",
    transform: "translate(21.711 24.467) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M.361,6a.816.816,0,0,0,1.305-.207l.788-1.265a7.425,7.425,0,0,0,.671,2.835,4.8,4.8,0,0,1,0,3.95L2.573,12.5a10.484,10.484,0,0,0,0,8.636.914.914,0,0,0,.806.577.794.794,0,0,0,.465-.155,1.32,1.32,0,0,0,.339-1.58,7.674,7.674,0,0,1,0-6.319l.552-1.185a7.608,7.608,0,0,0,0-6.266A4.649,4.649,0,0,1,4.321,4.56l.768,1.234a.879.879,0,0,0,.737.449A.819.819,0,0,0,6.395,6a1.352,1.352,0,0,0,.166-1.622L4.114.449A.88.88,0,0,0,3.378,0a.881.881,0,0,0-.736.449L.195,4.379A1.352,1.352,0,0,0,.361,6Z",
    transform: "translate(0)",
    fill: "#00a3da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M.361,6a.818.818,0,0,0,.569.242.878.878,0,0,0,.737-.448l.787-1.265a7.423,7.423,0,0,0,.671,2.835,4.8,4.8,0,0,1,0,3.95L2.573,12.5a10.483,10.483,0,0,0,0,8.635.915.915,0,0,0,.806.578.8.8,0,0,0,.465-.156,1.319,1.319,0,0,0,.339-1.58,7.674,7.674,0,0,1,0-6.319l.552-1.185a7.608,7.608,0,0,0,0-6.266A4.657,4.657,0,0,1,4.321,4.56L5.09,5.794A.816.816,0,0,0,6.395,6a1.352,1.352,0,0,0,.166-1.622L4.114.449A.88.88,0,0,0,3.378,0a.881.881,0,0,0-.736.449L.195,4.379A1.352,1.352,0,0,0,.361,6Z",
    transform: "translate(9.173 0)",
    fill: "#00a3da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M.361,6a.817.817,0,0,0,.569.242.878.878,0,0,0,.737-.448l.787-1.265a7.425,7.425,0,0,0,.671,2.835,4.8,4.8,0,0,1,0,3.95L2.573,12.5a10.484,10.484,0,0,0,0,8.636.914.914,0,0,0,.806.577.794.794,0,0,0,.465-.155,1.319,1.319,0,0,0,.339-1.58,7.674,7.674,0,0,1,0-6.319l.552-1.185a7.608,7.608,0,0,0,0-6.266A4.664,4.664,0,0,1,4.321,4.56L5.09,5.794A.816.816,0,0,0,6.395,6a1.352,1.352,0,0,0,.166-1.622L4.114.449A.881.881,0,0,0,3.378,0a.881.881,0,0,0-.736.449L.195,4.379A1.352,1.352,0,0,0,.361,6Z",
    transform: "translate(18.347)",
    fill: "#00a3da"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "breathable-2",
    "data-name": "breathable",
    transform: "translate(65.514 24.467) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M.361,6a.816.816,0,0,0,1.305-.207l.788-1.265a7.425,7.425,0,0,0,.671,2.835,4.8,4.8,0,0,1,0,3.95L2.573,12.5a10.484,10.484,0,0,0,0,8.636.914.914,0,0,0,.806.577.794.794,0,0,0,.465-.155,1.32,1.32,0,0,0,.339-1.58,7.674,7.674,0,0,1,0-6.319l.552-1.185a7.608,7.608,0,0,0,0-6.266A4.649,4.649,0,0,1,4.321,4.56l.768,1.234a.879.879,0,0,0,.737.449A.819.819,0,0,0,6.395,6a1.352,1.352,0,0,0,.166-1.622L4.114.449A.88.88,0,0,0,3.378,0a.881.881,0,0,0-.736.449L.195,4.379A1.352,1.352,0,0,0,.361,6Z",
    transform: "translate(0)",
    fill: "#00a3da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M.361,6a.818.818,0,0,0,.569.242.878.878,0,0,0,.737-.448l.787-1.265a7.423,7.423,0,0,0,.671,2.835,4.8,4.8,0,0,1,0,3.95L2.573,12.5a10.483,10.483,0,0,0,0,8.635.915.915,0,0,0,.806.578.8.8,0,0,0,.465-.156,1.319,1.319,0,0,0,.339-1.58,7.674,7.674,0,0,1,0-6.319l.552-1.185a7.608,7.608,0,0,0,0-6.266A4.657,4.657,0,0,1,4.321,4.56L5.09,5.794A.816.816,0,0,0,6.395,6a1.352,1.352,0,0,0,.166-1.622L4.114.449A.88.88,0,0,0,3.378,0a.881.881,0,0,0-.736.449L.195,4.379A1.352,1.352,0,0,0,.361,6Z",
    transform: "translate(9.173 0)",
    fill: "#00a3da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M.361,6a.817.817,0,0,0,.569.242.878.878,0,0,0,.737-.448l.787-1.265a7.425,7.425,0,0,0,.671,2.835,4.8,4.8,0,0,1,0,3.95L2.573,12.5a10.484,10.484,0,0,0,0,8.636.914.914,0,0,0,.806.577.794.794,0,0,0,.465-.155,1.319,1.319,0,0,0,.339-1.58,7.674,7.674,0,0,1,0-6.319l.552-1.185a7.608,7.608,0,0,0,0-6.266A4.664,4.664,0,0,1,4.321,4.56L5.09,5.794A.816.816,0,0,0,6.395,6a1.352,1.352,0,0,0,.166-1.622L4.114.449A.881.881,0,0,0,3.378,0a.881.881,0,0,0-.736.449L.195,4.379A1.352,1.352,0,0,0,.361,6Z",
    transform: "translate(18.347)",
    fill: "#00a3da"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseWind);
export default __webpack_public_path__ + "static/media/house-wind.8432e102a0911dd79222ea4c719966a9.svg";
export { ForwardRef as ReactComponent };